import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * The single place one of the boards' ratio strings — vehicles per rep, per branch, per
 * seller — is coerced to a number for the locale formatter. The backend sends two decimals
 * where the boards render one, deliberately, so the display rounding happens here rather
 * than being inherited.
 *
 * Null stays null: a ratio with no denominator is undefined, and 0 would assert something
 * false about the branch.
 */
export function parseRatio(ratio: string | Nullish): number | null {
  if (isNil(ratio)) {
    return null;
  }

  return Number(ratio);
}
